import { defineStore } from "pinia";
import { v4 as uuidv4 } from 'uuid';

export const useConnectionStore = defineStore('connectionStore', {
  state : () => ({
    //cookie : "",
    //dummy : 1,

    versionDate : "2026-05-08",
    versionID : import.meta.env.VITE_APP_VERSION,
    versionMajor : "10",

    cookie : null, //"$2y$10$foyP6pBVtKcn/3aFiEQJneJdqveHulH3Xqzocxyh0dwmT85OE7456",
    dummy : null,

    deviceType : null,
    toolbarHeight : 50,
    topIndent : null,
    leftIndent : null,
    
    isSubscriber : null,
    subscriberExpireDate : null,
    subscriberExpireDisplayString : null,
    lastStartupCheckDate : null,

    lastNewInfoDate : null,
    verified : null,
    email : null,
    coordinateLocation : null,

    isMe : null,

    // darkmode - set by system for overall screen.
    // darkBoardColors - what colors to use in dark mode
    darkmode : null,
    darkBoardColors : null,
    workOfflinePuzzles : null,
    puzzleCount : null,
    puzzleNext : null,
    visualizeCount : null,
    visualizeNext : null,
    puzzleAttemptCount : null,
    playComputerGameId : null,
    playComputerBlindfold : null,

    youAccordionToOpen : null,
    programAccordionToOpen : null,

    // type of puzzle, move following - anything that shares the same target routine
    productOption : null,
    tourOption : "hide",
    puzzleHistoryId : null,
    puzzleHistoryRating : null,
    puzzleHistoryReturnIndex : null,

    lichessAccessToken : null,
    lichessUserid : null,
    lichessGameId : null,

    disableHintButton : null,

    // learn with coach
    coachEmail : null,
    roomName : null,
    displayName : null,
    isCoach : null,
    sessionUUID : null,
    checkAudioVideo : null,
    sessionTimer : null,
    roomSounds : null,
    markupDefaults : null,

    // Audio book
    audiobookPageStack : null,
    audiobookCurrentPage : null,

      // this resolves the "system" language requested
    languageInUse : null,
    languageIncludingSystem : null,

    // big buttons
    showBigButtons : null,
    toolbarScalePercentage : null,
    isEyeGaze : null,
    whichBigButtonMenu : "main",

    // ai
    urlIsAI : false,

    // new menus
    menuInUse : null,
    menuSectionInUse : null,
    seenNewLandingPage : null,
    isUsingNewMenus : null,          // menu or hanburger user?

    // ai
    aiOpeningPersona : null

  }),
  getters: {
    getAiOpeningPersona() {
      if (this.aiOpeningPersona == null)
        this.aiOpeningPersona = localStorage.getItem("aiOpeningPersona")
      if (this.aiOpeningPersona == null)
        this.aiOpeningPersona = "normal"
      return (this.aiOpeningPersona)
    },
    getIsUsingNewMenus() {
      if (this.isUsingNewMenus == null)
        this.isUsingNewMenus = localStorage.getItem("isUsingNewMenus")
      if (this.isUsingNewMenus == null)
        this.isUsingNewMenus = "yes"
      return (this.isUsingNewMenus == "yes")
    },
    getSeenNewLandingPage() {
      if (this.seenNewLandingPage == null)
        this.seenNewLandingPage = localStorage.getItem("seenNewLandingPage")
      if (this.seenNewLandingPage == null)
        this.seenNewLandingPage = "no"
      return (this.seenNewLandingPage == "yes")
    },
    getMenuInUse() {
      if (this.menuInUse == null)
        this.menuInUse = "home"
      return (this.menuInUse)
    },
    getMenuSectionInUse() {
      if (this.menuSectionInUse == null)
        this.menuSectionInUse = ""
      return (this.menuSectionInUse)
    },
     getMenuInUse() {
      if (this.menuInUse == null)
        this.menuInUse = "home"
      return (this.menuInUse)
    },
    getUrlIsAI() {
      return this.urlIsAI
    },
    getWhichBigButtonMenu() {
      return this.whichBigButtonMenu
    },
    getIsEyeGaze() {
      if (this.isEyeGaze == null)
        this.isEyeGaze = localStorage.getItem("isEyeGaze")
      if (this.isEyeGaze == null)
        this.isEyeGaze = "no"
      return (this.isEyeGaze == "yes")
    },
    getToolbarScalePercentage() {
      if (this.toolbarScalePercentage == null)
        this.toolbarScalePercentage = localStorage.getItem("toolbarScalePercentage")
      if (this.toolbarScalePercentage == null)
        this.toolbarScalePercentage = "200"
      return (this.toolbarScalePercentage)
    },
    getShowBigButtons() {
      if (this.showBigButtons == null)
        this.showBigButtons = localStorage.getItem("showBigButtons")
      if (this.showBigButtons == null)
        this.showBigButtons = "no"
      return (this.showBigButtons == "yes")
    },
    getLanguageInUse() {
      if (this.languageInUse == null)
        this.languageInUse = localStorage.getItem("languageInUse")
      if (this.languageInUse == null)
        this.languageInUse = ""
      return this.languageInUse
    },
    getLanguageIncludingSystem() {
      if (this.languageIncludingSystem == null)
        this.languageIncludingSystem = localStorage.getItem("languageIncludingSystem")
      if (this.languageIncludingSystem == null)
        this.languageIncludingSystem = ""
      return this.languageIncludingSystem
    },
    getAudioBookPageStack() {
      var audiobookPageStackString = null
      var audiobookCurrentPageString = null

      if (this.audiobookPageStack == null)
        audiobookPageStackString = localStorage.getItem("audiobookPageStack")
      if (audiobookPageStackString == null)
        this.audiobookPageStack = []
      else
        this.audiobookPageStack = JSON.parse(audiobookPageStackString)

      if (this.audiobookCurrentPage == null)
        audiobookCurrentPageString = localStorage.getItem("audiobookCurrentPage")
      if (audiobookCurrentPageString == null)
        this.audiobookCurrentPage = null
      else
        this.audiobookCurrentPage = JSON.parse(audiobookCurrentPageString)

      return ( { pages: this.audiobookPageStack, current : this.audiobookCurrentPage })
    },
    getSessionUUID() {
      if (this.sessionUUID == null)
        this.sessionUUID = sessionStorage.getItem("sessionUUID")
      if (this.sessionUUID == null) {
        this.sessionUUID = uuidv4().replace(/-/g,"")
        sessionStorage.setItem("sessionUUID",this.sessionUUID)
      }
      return this.sessionUUID
    },
    getIsEyeGaze() {
      if (this.isEyeGaze == null)
        this.isEyeGaze = localStorage.getItem("isEyeGaze")
      if (this.isEyeGaze == null)
        this.isEyeGaze = "no"
      return (this.isEyeGaze == "yes")
    },
    getDeviceType() {
      if (this.deviceType == null)
        this.deviceType = localStorage.getItem("deviceType")
      if (this.deviceType == null)
        this.deviceType = "web"
      return this.deviceType
    },
    getLichessGameId() {
      if (this.lichessGameId == null)
        this.lichessGameId = localStorage.getItem("lichessGameId")
      if (this.lichessGameId == null)
        this.lichessGameId = ""
      return this.lichessGameId
    },
    getLichessAccessToken() {
      if (this.lichessAccessToken == null)
        this.lichessAccessToken = localStorage.getItem("lichessAccessToken")
      if (this.lichessAccessToken == null)
        this.lichessAccessToken = ""
      return (this.lichessAccessToken)
    },
    getLichessUserid() {
      if (this.lichessUserid == null)
        this.lichessUserid = localStorage.getItem("lichessUserid")
      if (this.lichessUserid == null)
        this.lichessUserid = ""
      return (this.lichessUserid)
    },
    getTourOption() {
      return this.tourOption
    },
    getProductOption() {
      if (this.productOption == null)
        this.productOption = localStorage.getItem("productOption")
      if (this.productOption == null)
        this.productOption = ""
      return this.productOption
    },
    getPuzzleHistoryId() {
      if (this.puzzleHistoryId == null)
        this.puzzleHistoryId = localStorage.getItem("puzzleHistoryId")
      if (this.puzzleHistoryId == null)
        this.puzzleHistoryId = ""
      return this.puzzleHistoryId
    },
    getPuzzleHistoryRating() {
      if (this.puzzleHistoryRating == null)
        this.puzzleHistoryRating = localStorage.getItem("puzzleHistoryRating")
      if (this.puzzleHistoryRating == null)
        this.puzzleHistoryRating = ""
      return this.puzzleHistoryRating
    },
    getPuzzleHistoryReturnIndex() {
      if (this.puzzleHistoryReturnIndex == null)
        this.puzzleHistoryReturnIndex = localStorage.getItem("puzzleHistoryReturnIndex")
      if (this.puzzleHistoryReturnIndex == null)
        this.puzzleHistoryReturnIndex = ""
      return this.puzzleHistoryReturnIndex
    },
    getLastStartupCheckDate() {
      if (this.lastStartupCheckDate == null)
        this.lastStartupCheckDate = localStorage.getItem("lastStartupCheckDate")
      if (this.lastStartupCheckDate == null)
        this.lastStartupCheckDate = "0"
      return this.lastStartupCheckDate
    },
    getIsSubscriber() {
      if (this.isSubscriber == null)
        this.isSubscriber = localStorage.getItem("isSubscriber")
      if (this.isSubscriber == null || this.isSubscriber != "1")
        this.isSubscriber = "0"
      return (this.isSubscriber)
    },

    getSubscriberExpireDate() {
      if (this.subscriberExpireDate == null)
        this.subscriberExpireDate = localStorage.getItem("subscriberExpireDate")
      if (this.subscriberExpireDate == null)
        this.subscriberExpireDate = 0
      return (this.subscriberExpireDate)
    },
    getSubscriberExpireDisplayString() {
      if (this.subscriberExpireDisplayString == null)
        this.subscriberExpireDisplayString = localStorage.getItem("subscriberExpireDisplayString")
      if (this.subscriberExpireDisplayString == null)
        this.subscriberExpireDisplayString = ""
      return (this.subscriberExpireDisplayString)
    },
    getLastNewInfoDate() {
      if (this.lastNewInfoDate == null)
        this.lastNewInfoDate = localStorage.getItem("lastNewInfoDate")
      if (this.lastNewInfoDate == null)
        this.lastNewInfoDate = 0
      return (this.lastNewInfoDate)
    },

    getCoordinateLocation() {
      if (this.coordinateLocation == null)
        this.coordinateLocation = localStorage.getItem("coordinateLocation")
      if (this.coordinateLocation == null)
        this.coordinateLocation = "in"
      return (this.coordinateLocation)
    },
    getIsMe() {
      if (this.isMe == null)
        this.isMe = localStorage.getItem("isMe")
      if (this.isMe == null)
        this.isMe = "0"
      return this.isMe
    },
    getEmailVerified() {
      if (this.verified == null)
        this.verified = localStorage.getItem("emailVerified")
      if (this.verified == null)
        this.verified = "no"
      return this.verified
    },
    getEmailAddress() {
      if (this.email == null)
        this.email = localStorage.getItem("email")
      if (this.email == null)
        this.email = ""
      return this.email
    },
    getDarkmode() {
      // see if darkmode already set, also fix any old values
      if (this.darkmode == null)
        this.darkmode = localStorage.getItem("dark")
      if (this.darkmode == null || this.darkmode == "n" || this.darkmode == "")
        this.darkmode = "light"
      else
      if (this.darkmode == "y")
        this.darkmode = "dark"
      return (this.darkmode)
    },
    getDarkBoardColors() {
      if (this.darkBoardColors == null)
        this.darkBoardColors = localStorage.getItem("darkBoardColors")
      if (this.darkBoardColors == null)
        this.darkBoardColors = "dark"
      return this.darkBoardColors
    },
    getWorkOfflinePuzzles() {
      if (this.workOfflinePuzzles == null)
        this.workOfflinePuzzles = localStorage.getItem("workOfflinePuzzles")
      if (this.workOfflinePuzzles == null)
        this.workOfflinePuzzles = "no"
      return this.workOfflinePuzzles
    },
    getPuzzleCount() {
      if (this.puzzleCount == null)
        this.puzzleCount = localStorage.getItem("puzzleCount")
      if (this.puzzleCount == null)
        this.puzzleCount = "0"
      return this.puzzleCount
    },
    getPuzzleNext() {
      if (this.puzzleNext == null)
        this.puzzleNext = localStorage.getItem("puzzleNext")
      if (this.puzzleNext == null)
        this.puzzleNext = "0"
      return this.puzzleNext
    },
    getvisualizeCount() {
      if (this.visualizeCount == null)
        this.visualizeCount = localStorage.getItem("visualizeCount")
      if (this.visualizeCount == null)
        this.visualizeCount = "0"
      return this.visualizeCount
    },
    getVisualizeNext() {
      if (this.visualizeNext == null)
        this.visualizeNext = localStorage.getItem("visualizeNext")
      if (this.visualizeNext == null)
        this.visualizeNext = "0"
      return this.visualizeNext
    },
    getPuzzleAttemptCount() {
      if (this.puzzleAttemptCount == null)
        this.puzzleAttemptCount = localStorage.getItem("puzzleAttemptCount")
      if (this.puzzleAttemptCount == null)
        this.puzzleAttemptCount = "0"
      return this.puzzleAttemptCount
    },
    getPlayComputerGameId() {
      if (this.playComputerGameId == null)
        this.playComputerGameId = localStorage.getItem("playComputerGameId")
      if (this.playComputerGameId == null)
        this.playComputerGameId = "0"
      return this.playComputerGameId
    },
    getPlayComputerBlindfold() {
      if (this.playComputerBlindfold == null)
        this.playComputerBlindfold = localStorage.getItem("playComputerBlindfold")
      if (this.playComputerBlindfold == null)
        this.playComputerBlindfold = "computer"
      return this.playComputerBlindfold
    },
    getCookie() {
      //console.log("IN GET COOKIE",localStorage.getItem("cookie"))
      if (this.cookie == null)
        this.cookie = localStorage.getItem("cookie")
      if (this.cookie == null)
        this.cookie = ""

      return this.cookie
    },
    getDummy() {
      if (this.dummy == null)
        this.dummy = localStorage.getItem("dummy")
      if (this.dummy == null)
        this.dummy = "1"
      return this.dummy
    },
    getYouAccordionToOpen() {
      if (this.youAccordionToOpen == null)
        this.youAccordionToOpen = localStorage.getItem("youAccordionToOpen")
      if (this.youAccordionToOpen == null)
        this.youAccordionToOpen = "account"
      return this.youAccordionToOpen
    },
    getProgramAccordionToOpen() {
      if (this.programAccordionToOpen == null)
        this.programAccordionToOpen = localStorage.getItem("programAccordionToOpen")
      if (this.programAccordionToOpen == null)
        this.programAccordionToOpen = ""
      return this.programAccordionToOpen
    },
    getToolbarHeight() {
      // if (this.toolbarHeight == null)
      //   this.toolbarHeight = localStorage.getItem("toolbarHeight")
      // if (this.toolbarHeight == null)
      //   this.toolbarHeight = "50"
      return this.toolbarHeight
    },
    getTopIndent() {
      if (this.topIndent == null)
        this.topIndent = localStorage.getItem("topIndent")
      if (this.topIndent == null)
        this.topIndent = "56"
      return this.topIndent
    },
    getLeftIndent() {
      if (this.leftIndent == null)
        this.leftIndent = localStorage.getItem("leftIndent")
      if (this.leftIndent == null)
        this.leftIndent = "0"
      return this.leftIndent
    },
    getLearnCoachEmail() {
      if (this.coachEmail == null)
        this.coachEmail = localStorage.getItem("coachEmail")
      if (this.coachEmail == null)
        this.coachEmail = ""
      return (this.coachEmail)
    }, 
    getLearnRoomName() {
      if (this.roomName == null)
        this.roomName = localStorage.getItem("roomName")
      if (this.roomName == null)
        this.roomName = ""
      return (this.roomName)
    },
    getLearnDisplayName() {
      if (this.displayName == null)
        this.displayName = localStorage.getItem("displayName")
      if (this.displayName == null)
        this.displayName = ""
      return (this.displayName)
    },
    getCoach() {
      // obscure the text string for coach
      if (this.isCoach == null)
        this.isCoach = localStorage.getItem("blahblah")
      if (this.isCoach == null)
        this.isCoach = ""
      return (this.isCoach)
    },
    getCheckAudioVideo() {
      if (this.checkAudioVideo == null)
        this.checkAudioVideo = localStorage.getItem("checkAudioVideoDefaultAudio")
      if (this.checkAudioVideo == null)
        this.checkAudioVideo = "audio"
      return (this.checkAudioVideo)
    },
    getSessionTimer() {
      if (this.sessionTimer == null)
        this.sessionTimer = localStorage.getItem("sessionTimer")
      if (this.sessionTimer == null)
        this.sessionTimer = ""
      return (this.sessionTimer)
    },
    getRoomSounds() {
      if (this.roomSounds == null)
        this.roomSounds = localStorage.getItem("roomSounds")
      if (this.roomSounds == null)
        this.roomSounds = ""
      return (this.roomSounds)
    },
    getMarkupDefaults() {
      if (this.markupDefaults == null)
        this.markupDefaults = localStorage.getItem("markupDefaults")
      if (this.markupDefaults == null)
        this.markupDefaults = "yellow,fill"
      return (this.markupDefaults)
    },    
    getDisableHintButton() {
      if (this.disableHintButton == null)
        this.disableHintButton = localStorage.getItem("disableHintButton")
      if (this.disableHintButton == null)
        this.disableHintButton = "no"
      return (this.disableHintButton == "yes")
    },
  },
  actions: {
    setAiOpeningPersona(aiOpeningPersona) {
      this.aiOpeningPersona = aiOpeningPersona
      localStorage.setItem("aiOpeningPersona",this.aiOpeningPersona)
    },
    setSeenNewLandingPage(seenNewLandingPage) {
      this.seenNewLandingPage = seenNewLandingPage ? "yes" : "no"
      localStorage.setItem("seenNewLandingPage",this.seenNewLandingPage)
    },
    setIsUsingNewMenus(isUsingNewMenus) {
      this.isUsingNewMenus = isUsingNewMenus ? "yes" : "no"
      localStorage.setItem("isUsingNewMenus",this.isUsingNewMenus)
    },
    setMenuInUse(menuInUse) {
      this.menuInUse = menuInUse
    },
    setMenuSectionInUse(menuSectionInUse) {
      this.menuSectionInUse = menuSectionInUse
    },
    setUrlIsAI(urlIsAI) {
      this.urlIsAI = urlIsAI
    },
    setWhichBigButtonMenu(whichBigButtonMenu) {
      this.whichBigButtonMenu = whichBigButtonMenu
    },
    setLanguageInUse(languageInUse) {
      this.languageInUse = languageInUse
      localStorage.setItem("languageInUse",languageInUse)
    },
    setLanguageIncludingSystem(language) {
      this.languageIncludingSystem = language
      localStorage.setItem("languageIncludingSystem",language)
    },
    setEmailAddress(email) {
      this.email = email
      localStorage.setItem("email","" + email)
    },
    setIsSubscriber(isSubscriber) {
      this.isSubscriber = isSubscriber
      localStorage.setItem("isSubscriber","" + isSubscriber)
    },
    setSubscriberExpireDate(subscriberExpireDate) {
      this.subscriberExpireDate = subscriberExpireDate
      localStorage.setItem("subscriberExpireDate","" + subscriberExpireDate)
    },
    setSubscriberExpireDisplayString(subscriberExpireDisplayString) {
      this.subscriberExpireDisplayString = subscriberExpireDisplayString
      localStorage.setItem("subscriberExpireDisplayString",subscriberExpireDisplayString)
    },
    setLastStartupDate(startupDate) {
      this.lastStartupCheckDate = startupDate
      localStorage.setItem("lastStartupCheckDate","" + startupDate)
    },
    setLastNewInfoDate(startupDate) {
      this.lastNewInfoDate = startupDate
      localStorage.setItem("lastNewInfoDate","" + startupDate)
    },
    setEmailVerified(verified) {
      this.verified = verified
      localStorage.setItem("emailVerified","" + verified)
    },
    setIsMe(isMeFlag) {
      this.isMe = isMeFlag
      localStorage.setItem("isMe","" + isMeFlag)
    },
    setPuzzleCount(puzzleCount) {
      this.puzzleCount = puzzleCount
      localStorage.setItem("puzzleCount","" + puzzleCount)
    },
    setPuzzleNext(puzzleNext) {
      this.puzzleNext = puzzleNext
      localStorage.setItem("puzzleNext","" + puzzleNext)
    },
    setVisualizeCount(visualizeCount) {
      this.visualizeCount = visualizeCount
      localStorage.setItem("visualizeCount","" + visualizeCount)
    },
    setVisualizeNext(visualizeNext) {
      this.visualizeNext = visualizeNext
      localStorage.setItem("visualizeNext","" + visualizeNext)
    },
    setPuzzleAttemptCount(puzzleAttemptCount) {
      this.puzzleAttemptCount = puzzleAttemptCount
      localStorage.setItem("puzzleAttemptCount","" + puzzleAttemptCount)
    },
    setPlayComputerGameId(playComputerGameId) {
      this.playComputerGameId = playComputerGameId
      localStorage.setItem("playComputerGameId","" + playComputerGameId)
    },
    setPlayComputerBlindfold(playComputerBlindfold) {
      this.playComputerBlindfold = playComputerBlindfold
      localStorage.setItem("playComputerBlindfold","" + playComputerBlindfold)
    },
    setCoordinateLocation(coordinateLocation) {
      this.coordinateLocation = coordinateLocation
      localStorage.setItem("coordinateLocation","" + coordinateLocation)
    },
    setLichessAccessToken(token) {
      this.lichessAccessToken = token
      localStorage.setItem("lichessAccessToken",token)
    },
    setLichessUserid(userid) {
      this.lichessUserid = userid
      localStorage.setItem("lichessUserid",userid)
    },
    setYouAccordionToOpen(accordion) {
      this.youAccordionToOpen = accordion
      localStorage.setItem("youAccordionToOpen","" + accordion)
    },
    setProgramAccordionToOpen(accordion) {
      this.programAccordionToOpen = accordion
      localStorage.setItem("programAccordionToOpen","" + accordion)
    },
    setToolbarHeight(toolbarHeight) {
      this.toolbarHeight = toolbarHeight
      localStorage.setItem("toolbarHeight","" + toolbarHeight)
    },
    setTopIndent(topIndent) {
      this.topIndent = topIndent
      localStorage.setItem("topIndent","" + topIndent)
    },
    setLeftIndent(leftIndent) {
      this.leftIndent = leftIndent
      localStorage.setItem("leftIndent","" + leftIndent)
    },
    setUserCookieDummy(cookie,dummy) {
      //console.log("in setUserCookieDummy",cookie,dummy)
      this.cookie = cookie
      localStorage.setItem("cookie",cookie)
      this.dummy = dummy
      localStorage.setItem("dummy",dummy)

      // zero out all the other fields on a setting of cookie & dummy. will reload from server
      this.lastStartupCheckDate = null
      this.lastNewInfoDate = null
      this.isSubscriber = null
      this.subscriberExpireDate = null
      this.subscriberExpireDisplayString = null
      this.isMe = null
      this.verified = null

      localStorage.removeItem("isSubscriber")
      localStorage.removeItem("lastStartupCheckDate")
      localStorage.removeItem("lastNewInfoDate")
      localStorage.removeItem("subscriberExpireDate")
      localStorage.removeItem("subscriberExpireDisplayString")
      localStorage.removeItem("isMe")
      localStorage.removeItem("emailVerified")
    },

    setDarkMode(darkmode) {
      this.darkmode = darkmode
      localStorage.setItem("dark",darkmode)
    },
    setDarkBoardColors(darkBoardColors) {
      this.darkBoardColors = darkBoardColors
      localStorage.setItem("darkBoardColors",darkBoardColors)
    },
    setWorkOfflinePuzzles(workOfflinePuzzles) {
      this.workOfflinePuzzles = workOfflinePuzzles
      localStorage.setItem("workOfflinePuzzles",workOfflinePuzzles)
    },
    setTourOption(tourOption) {
      this.tourOption = tourOption
    },
    setProductOption(productOption) {
      this.productOption = productOption
      localStorage.setItem("productOption",productOption)
    },
    setPuzzleHistoryId(puzzleHistoryId) {
      this.puzzleHistoryId = puzzleHistoryId
      localStorage.setItem("puzzleHistoryId",puzzleHistoryId)
    },
    setPuzzleHistoryRating(puzzleHistoryRating) {
      this.puzzleHistoryRating = puzzleHistoryRating
      localStorage.setItem("puzzleHistoryRating",puzzleHistoryRating)
    },
    setPuzzleHistoryReturnIndex(puzzleHistoryReturnIndex) {
      this.puzzleHistoryReturnIndex = puzzleHistoryReturnIndex
      localStorage.setItem("puzzleHistoryReturnIndex",puzzleHistoryReturnIndex)
    },
    setGameId(gameId) {
      this.gameId = gameId
      localStorage.setItem("gameId",gameId)
    },
    setLichessGameId(lichessGameId) {
      this.lichessGameId = lichessGameId
      localStorage.setItem("lichessGameId",lichessGameId)
    },
    setDeviceType(deviceType) {
      this.deviceType = deviceType
      localStorage.setItem("deviceType",deviceType)
    },
    setLearnCoachEmail(coachEmail) {
      this.coachEmail = coachEmail
      localStorage.setItem("coachEmail",coachEmail)
    },
    setLearnRoomName(roomName) {
      this.roomName = roomName
      localStorage.setItem("roomName",roomName)
    },
    setLearnDisplayName(displayName) {
      this.displayName = displayName
      localStorage.setItem("displayName",displayName)
    },
    setCoach(isCoach) {
      this.isCoach = isCoach
      localStorage.setItem("blahblah",isCoach)
    },
    setCheckAudioVideo(checkAudioVideo) {
      this.checkAudioVideo = checkAudioVideo
      localStorage.setItem("checkAudioVideoDefaultAudio",checkAudioVideo)
    },
    setSessionTimer(sessionTimer) {
      this.sessionTimer = sessionTimer
      localStorage.setItem("sessionTimer",sessionTimer)
    },
    setRoomSounds(roomSounds) {
      this.roomSounds = roomSounds
      localStorage.setItem("roomSounds",roomSounds)
    },
    setMarkupDefaults(markupDefaults) {
      this.markupDefaults = markupDefaults
      localStorage.setItem("markupDefaults",markupDefaults)
    },
    setDisableHintButton(disableHintButton) {
      this.disableHintButton = disableHintButton ? "yes" : "no"
      localStorage.setItem("disableHintButton",this.disableHintButton)
    },
    setIsEyeGaze(isEyeGaze,saveInLocalStorage) {
      this.isEyeGaze = isEyeGaze ? "yes" : "no"

      // don't save if from the url. make it this session only
      if (saveInLocalStorage)
        localStorage.setItem("isEyeGaze",this.isEyeGaze)
    },
    setShowBigButtons(showBigButtons,saveInLocalStorage) {
      this.showBigButtons = showBigButtons ? "yes" : "no"

      // don't save if from the url. make it this session only
      if (saveInLocalStorage)
        localStorage.setItem("showBigButtons",this.showBigButtons)
    },
    setToolbarScalePercentage(percentage,saveInLocalStorage) {
      this.toolbarScalePercentage = percentage
      
      // don't save if from the url. make it this session only
      if (saveInLocalStorage)
        localStorage.setItem("toolbarScalePercentage",this.toolbarScalePercentage)
    },
    setAudioBookPageStack(pageStack,currentPage) {
      this.audiobookPageStack = pageStack
      this.audiobookCurrentPage = currentPage

      localStorage.setItem("audiobookPageStack",JSON.stringify(pageStack))
      localStorage.setItem("audiobookCurrentPage",JSON.stringify(currentPage))
   },
  }

})
